import React, { useState } from "react";
import close from "../../Pages/MyProfile/assets/close.png";
import ChainSelection from "../../Pages/MyProfile/ChainSelection/ChainSelection";

const AddRaiseModal = ({ open, setOpen, thum, icon1, icon2, gold }) => {
  const [title, setTitle] = useState("");
  const [refreshit, setrefreshit] = useState(false);
  const handleWrapClick = (e) => {
    e.stopPropagation();
    setOpen(false);
  };

  const handleTitle = (event) => {
    const inputValue = event.target.value;
    setTitle(inputValue);
  };

  return (
    <>
      <div
        onClick={handleWrapClick}
        style={{scrollbarWidth: "none",}}
        className="fixed z-20   max-h-screen   overflow-y-scroll  removeScroll top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 flex justify-center items-start "
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className="bg-main-black w-[350px] md:w-[481px] h-max  mt-[60px] md:mt-[100px] rounded-[20px]"
        >
          {/* header */}
          <div className="flex justify-between items-center pt-[31px] pl-[10px] md:pl-[36px] pr-[10px] md:pr-[24px] pb-[20px]">
            <h2 className="text-res-normal font-semibold ">Raise Form </h2>
            <button
              onClick={() => {
                setOpen(false);
              }}
              style={{
                boxShadow: "0px 0.909091px 1.81818px rgba(165, 163, 174, 0.3)",
              }}
              className="w-[20px] flex justify-center items-center h-[20px] bg-main-green rounded-[2px] "
            >
              <img src={close} alt="close" />
            </button>
          </div>
          <div className="px-[10px] md:pl-[36px] md:pr-[31px]">
            {/* thumbnail area  */}
            <div>
              <div
                style={{ position: "relative" }}
                className="flex h-[48px] bg-[#09090A] border border-main-green rounded-[6px] overflow-hidden text-res-ls mt-[20px]"
              >
                <input
                  onChange={handleTitle}
                  className="placeholder:text-white/60  flex-grow bg-transparent active:border-0 focus:border-0 focus:outline-none   px-[16px]  border-r-0"
                  type="number "
                  placeholder="Project Name"
                />
              </div>
              <div
                style={{ position: "relative" }}
                className="flex h-[48px] bg-[#09090A] border border-main-green rounded-[6px] overflow-hidden text-res-ls mt-[20px]"
              >
                <input
                  className="placeholder:text-white/60  flex-grow bg-transparent active:border-0 focus:border-0 focus:outline-none   px-[16px]  border-r-0"
                  type="text"
                  placeholder="Access Tier"
                />
              </div>
              <div
                style={{ position: "relative" }}
                className="flex h-[48px] bg-[#09090A] border border-main-green rounded-[6px] overflow-hidden text-res-ls mt-[20px]"
              >
                <input
                  className="placeholder:text-white/60  flex-grow bg-transparent active:border-0 focus:border-0 focus:outline-none   px-[16px]  border-r-0"
                  type="number "
                  placeholder="Participants"
                />
              </div>
              <ChainSelection
                  className="mt-[20px] color-white"
                  options={["Ethereum",  "BNB Smart Chain", "Arbitrum","Polygon", "Avalanche"]}
                  images={["eth", "bsc", "arb", "pol", "ava"]}
                  defaultValue={"Ethereum"}
                  defaultImage={"eth"}
                  />
              <div
                style={{ position: "relative" }}
                className="flex h-[240px] py-[16px] bg-[#09090A] border border-main-green rounded-[6px] overflow-hidden text-res-ls mt-[20px]"
              >
                <textarea
                  className="placeholder:text-white/60 overflow-y-hidden flex-grow bg-transparent active:border-0 focus:border-0 focus:outline-none   px-[16px]  border-r-0"
                  type="number "
                  placeholder="Short Description"
                />
              </div>
              <div>
                <div className="mt-[16px] pb-[52px]">
                  <button className="bg-main-green text-[#0E0E0E] font-bold text-res-xs h-[40px] w-full rounded-[6px]">
                    Add Raise
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div onClick={() => setOpen(false)} className="fixed inset-0  z-10"></div>
    </>
  );
};

export default AddRaiseModal;
